export default __webpack_public_path__ + "static/media/github.9544f549.svg";